export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('app:rendered', () => {
    const allEvents = emitter.all;
    for (const [eventType, handlers] of allEvents) {
      emitter.off(eventType);
    }
    allEvents.clear();
  });
});
